exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card__img[data-v-6c1d524d]{margin:-20px -20px 0}img[data-v-6c1d524d]{max-width:100%;height:auto;border:0;vertical-align:middle;-webkit-box-sizing:border-box;box-sizing:border-box}.card__desc[data-v-6c1d524d]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c1d524d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/teams/teamListItem.vue
// module id = 2NAO
// module chunks = 0